import { default as i18n } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import numbro from 'numbro'
import { initReactI18next } from 'react-i18next'
import { HashedHttpBackend } from './backends'
import { initOptions } from './config'

// TODO: Replace the Copyright and the Login Intro with their actual text
// https://mcatcama.visualstudio.com/Puma/_workitems/edit/5407
i18n.use(initReactI18next)
  .use(HttpApi)
  .use(new HashedHttpBackend())
  .use(LanguageDetector)
  .init(initOptions)

i18n.on('languageChanged', (language) => {
  numbro.setLanguage(language)
})
